import { useBillingAcceptanceAdvancedQuery } from '@shared/api/graphql/generated';
import { FetchPolicyKeys } from '@shared/api/graphql/types';

const useAcceptanceAdvanced = (companyId: string) => {
  const { data, loading, error, refetch, startPolling, stopPolling } = useBillingAcceptanceAdvancedQuery({
    fetchPolicy: FetchPolicyKeys.NETWORK_ONLY,
    skip: !companyId,
    variables: {
      companyId,
    },
  });

  const acceptanceAdvanced = data?.acceptanceAdvancedQuery;

  return {
    error,
    loading,
    acceptanceAdvanced,
    startPolling,
    stopPolling,
    refetch,
  };
};

export default useAcceptanceAdvanced;
